﻿module Client.ContractPage.CostOfConstruction.Expanded.Config

let smallTextSize = "0.87rem"
